export default function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie.split(';');
  const matchingCookie = cookies
    .map((cookie) => cookie.trim().split('='))
    .find(([cookieName]) => cookieName === name);

  return matchingCookie ? decodeURIComponent(matchingCookie[1]) : null;
}
